import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShow) = $event)),
    title: _ctx.title,
    onClose: _ctx.closeDialog,
    width: _ctx.width
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.closeDialog }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _withModifiers(_ctx.addOrEdit, ["stop"])
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("确定")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "form", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "title", "onClose", "width"]))
}